import React from 'react';

import { Grid } from '@material-ui/core';
import { useToggleBtnStyle } from './useToggleBtnStyle';

function MyEirToggleBtn() {
    const classes = useToggleBtnStyle();
    const toggleClass = event => {

    };
    return (
        <div className={classes.toggleSection}>
            <Grid container spacing={6}>
                <Grid item xs={12} sm={12} md={12}>

                    <div className='alignbtn primary'>
                        <input
                            type='button'
                            value='Log in '
                            className='toggleBtn primary ActiveBtn '
                        />
                        <span id="triangleSpan" class="arrow-down"></span>
                        {/* <span id='triangleSpan' className='arrow-down'></span> */}
                    </div>

                    <a href='https://my.eir.ie/bundles/register' target="_blank">
                        <div className='alignbtn secondary'>
                            <input
                                type='submit'
                                value='Register'
                                className='toggleBtn secondary regbtn'
                                onClick={toggleClass}
                            />
                        </div>
                    </a>
                </Grid>
            </Grid>
        </div>
    );
}

export default MyEirToggleBtn;
